module.exports = __webpack_public_path__ + "afc9c38fb3b795b3c7af3cac56d2a448.svg";